import {safeJSONparse} from "./safeJSONparse";

export const FEATURE_ENABLE_CACHING = "FEATURE_ENABLE_CACHING";
export const FEATURE_CAN_USE_MANUAL_QUERY = "FEATURE_CAN_USE_MANUAL_QUERY";
export const FEATURE_CAN_USE_COMPANY_SEARCH = "FEATURE_CAN_USE_COMPANY_SEARCH";
export const FEATURE_CAN_USE_COMMUNICATION_FEED = "FEATURE_CAN_USE_COMMUNICATION_FEED";
export const FEATURE_CAN_USE_RELATIONS = "FEATURE_CAN_USE_RELATIONS";
export const FEATURE_CAN_SEE_ORGANISATIONS = "FEATURE_CAN_SEE_ORGANISATIONS";
export const FEATURE_DASHBOARD = "FEATURE_DASHBOARD";
export const FEATURE_ADDONS = "FEATURE_ADDONS";
export const FEATURE_FLOWS = "FEATURE_FLOWS";
export const FEATURE_TASKS = "FEATURE_TASKS";
export const FEATURE_API_KEYS = "FEATURE_API_KEYS";
export const FEATURE_DEV_PORTAL = "FEATURE_DEV_PORTAL";
export const FEATURE_CAN_SEE_USERS = 'FEATURE_CAN_SEE_USERS';

const allFlags = [
    FEATURE_CAN_USE_COMPANY_SEARCH,
    FEATURE_FLOWS,
    FEATURE_CAN_SEE_USERS,
];

export function hasFeatureFlag(perm, user) {
    if (allFlags.indexOf(perm) !== -1) {
        return true;
    }

	let hasPermission = false;
	if (user && user.featureFlags) {
		hasPermission = isPermInFeatureFlags(perm, user.featureFlags);

		if (!hasPermission && user.organisation && user.organisation.featureFlags) {
			hasPermission = isPermInFeatureFlags(perm, user.organisation.featureFlags);
		}
	}

	return hasPermission;
}

function isPermInFeatureFlags(perm, featureFlags) {
	if (typeof featureFlags === "string") {
		featureFlags = safeJSONparse(featureFlags);
	}
	if (Array.isArray(featureFlags) && featureFlags.indexOf(perm) !== -1) {
		return true;
	}

	return false;
}
